<template>
	<InputRow
		class="value-row-input value-row-option"
		:class="{ hidden: hidden }"
		:for-id="uuid.toString()"
		:label="label"
	>
		<OptionInput
			:label-id="uuid.toString()"
			:disabled="isDisabled"
			:options
			:model-value="modelValue"
			@update:model-value="update($event)"
		/>
	</InputRow>
</template>

<script setup lang="ts">
import { useUserStore } from "@/store/useUserStore";
import { computed } from "vue";
import type { ValueType } from "@/enums/ValueType";
import { isNumeric } from "@/helpers/valueTypeHelpers";
import { stringIsValue } from "@/helpers/inputHelpers";
import type { AvailableOptionTypes } from "@/composables/useOptionsToArray";

const props = withDefaults(
	defineProps<{
		modelValue?: string | number;
		required?: boolean;
		config?: any;
		uuid?: number;
		readOnly?: boolean;
		hidden?: boolean;
		label: string;
		options: AvailableOptionTypes;
		disableNoSelection?: boolean;
		validations?: any;
		valueType?: ValueType;
	}>(),
	{
		required: false,
		uuid: 0,
		readOnly: false,
		hidden: false,
		disableNoSelection: true,
		validations: {},
	},
);

const emit = defineEmits<{
	"update:modelValue": [value: string | number | boolean | undefined];
}>();

/**
 * Formats and emits the newValue passed to the function.
 *
 * @param newValue - The new value to emit
 */
function update(newValue?: string | number | boolean) {
	if (isNumeric(props.valueType)) {
		newValue = stringIsValue(newValue);
	}
	emit("update:modelValue", newValue);
}

const userStore = useUserStore();
const isDisabled = computed(() => {
	return props.readOnly || userStore.user?.role !== "intermediary";
});
</script>
